import { PaneHeader } from '@/components/settings/pane-header';
import { SessionsEditor } from '@/components/settings/work-plan/sessions-editor';
import { FlagsEditor } from '@/components/settings/work-plan/flags-editor';
import { ScrollArea } from '@/components/ui/scroll-area';

// Hosts the two Work Plan config editors: the AM/PM session hours + labels, and the staff-flag
// vocabulary planners attach to posted people. Both shared org-wide; editing needs
// scheduling:manage (the same gate as Work roles).
export function WorkPlanSubPage({ canEdit }) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PaneHeader
        title="Work plan"
        description="Session hours and the staff flags planners can attach to a posting. Shared with your whole team."
      />
      <ScrollArea className="min-h-0 flex-1" viewportClassName="p-6">
        <div className="mx-auto flex max-w-3xl flex-col gap-8">
          <section className="flex flex-col gap-3">
            <div>
              <h3 className="text-[15px] font-bold text-foreground">Session hours</h3>
              <p className="text-xs text-muted-foreground">
                The two sessions every clinic day is planned in. Rename them or move the hours; the keys stay AM / PM.
              </p>
            </div>
            <SessionsEditor canEdit={canEdit} />
          </section>
          <section className="flex flex-col gap-3">
            <div>
              <h3 className="text-[15px] font-bold text-foreground">Staff flags</h3>
              <p className="text-xs text-muted-foreground">
                Markers for a posted person — "Stay back roster", "Key holder" — with an icon, a colour and a short meaning.
              </p>
            </div>
            <FlagsEditor canEdit={canEdit} />
          </section>
        </div>
      </ScrollArea>
    </div>
  );
}
